import { useState, useEffect } from 'react'
import { Outlet, useFetcher } from 'react-router'
import { ChatWidget } from './chat-widget.tsx'
import { CommandPalette } from './command-palette.tsx'
import { Sidebar } from './sidebar.tsx'
import { useHotkeys } from '#app/hooks/use-hotkeys.tsx'

interface RecentQuote {
  id: string
  companyName: string
  createdAt: string
}

export function DashboardLayout() {
  const [commandOpen, setCommandOpen] = useState(false)
  const fetcher = useFetcher<{ quotes: RecentQuote[] }>()

  useEffect(() => {
    void fetcher.load('/resources/quotes/recent')
  }, [])
  
  // Global hotkey for command palette
  useHotkeys({
    key: 'k',
    meta: true,
    callback: () => setCommandOpen(true)
  })


  const recentQuotes = fetcher.data?.quotes || []

  return (
    <>
      <Sidebar 
        recentQuotes={recentQuotes} 
        onSearchClick={() => setCommandOpen(true)}
      >
        {/* Main Content - routes will render their own headers */}
        <Outlet />
      </Sidebar>
      <CommandPalette open={commandOpen} onOpenChange={setCommandOpen} />
      <ChatWidget />
    </>
  )
}